// pages/BlogPage.tsx
import { useEffect, useState } from "react";
import axios from "axios";
import BlogCard from "../components/Blogs/BlogCard";
import BlogSlider from "../components/Blogs/BlogSlider";

export default function BlogPage() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await axios.get("http://127.0.0.1:8000/blogs");
        setBlogs(res.data);
      } catch (err) {
        console.error("Error fetching blogs:", err);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div className=" max-w-7xl mx-auto">
      {/* Blog Grid */}
       <BlogSlider blogs={blogs} />
   
  </div>
  );
}
